import { render } from "./DexDataTable.vue?vue&type=template&id=31a88146"
import script from "./DexDataTable.vue?vue&type=script&lang=js"
export * from "./DexDataTable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__